<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->

    <Banner
      title="Activity"
      subtitle="Activity"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">성장–폴리오 과정</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-read-wrap">
          <div>
            <ul class="line line4">
              <li>성장 – 폴리오 프로젝트</li>
              <li>
                <dl class="line2">
                  <dt>제목</dt>
                  <dd>성장 – 폴리오_대학생 과정</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <figure>
                  <n-space justify="center">
                    <img
                      src="@/assets/thum_img/kp708b/sub5_2/04490c28b366f8babe8d4506e8aad79a_water__c1_w280_h397.jpg"
                      alt=""
                    />
                  </n-space>
                </figure>
              </li>
              <li>
                <dl>
                  <dt>목적</dt>
                  <dd>
                    "성장–폴리오_대학생 과정"은 개인의 재능과 역량을 발굴하고
                    새로운 경험을 디자인하는 활동으로,<br />
                    자신의 '성장시스템' 구축 과정을 통해 자아 발견하고, 이를
                    기반으로 자아 성장 틀을 제작하는 데 목적이 있다.<br />
                  </dd>
                </dl>

                <dl>
                  <dt>목표</dt>
                  <dd>
                    목표1. 미미한 또는 숨겨진 역량-재능, 활동 및 경험을
                    브레인스토밍 한다.
                    <br />
                    목표2. 발굴해 낸 재능 및 역량, 활동 및 경험을
                    (활동지의)'성장모델'에 입력하여, 'MY 성장시스템'을
                    생성한다.<br />
                    목표3. 'MY 성장시스템'의 역량-재능에 캐릭터 혹은 스토리를
                    부여하여, '특별한 나', '최고의 나'를 만드는 경험 지도를
                    완성한다. <br />
                    목표4. 모든 참가자가 'MY 성장시스템'을 발표한다. 이때 또래
                    평가를 진행한다.<br />
                  </dd>
                </dl>

                <dl>
                  <dt>대상</dt>
                  <dd>대1 - 대4</dd>
                </dl>

                <dl class="line2">
                  <dt>구분·시수</dt>
                  <dd>4시간</dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line line4">
              <li>
                결과물<br />
                'MY 성장시스템'
              </li>
              <li>
                <dl class="line2">
                  <dt>구성</dt>
                  <dd>
                    • 모듈 1. [강의] (1) 프로그램 소개 , (2) 안전 교육<br />
                    • 모듈 2. 재능 및 역량, 활동 및 경험 브레인스토밍<br />
                    • 모듈 3. 재능 및 역량, 활동 및 경험 캐기<br />
                    • 모듈 4. 재능 및 역량, 활동 및 경험 디자인<br />
                    • 모듈 5. 'MY 성장시스템'의 발표 및 평가<br />
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line box22">
              <li>
                강의<br />
                • 선발 및 진학 전문가 <br />
                • ‘성장 –폴리오 전문가 과정’수료자<br />
              </li>
              <li>
                <dl class="line2">
                  <dt>이수혜택</dt>
                  <dd>
                    취업, 전공 탐색, 편입 등의 상황에서 자기소개 자료 제작의
                    기초 자료로 활용하거나 Port-folio로 활용<br />
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div class="btn">
            <router-link :to="`${USER_ROUTES.Product.Activity.Growth.Path}`"
              >목록</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.menu-A-read-wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  word-break: keep-all;
  box-sizing: border-box;
}
.menu-A-read-wrap > div h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.menu-A-read-wrap > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu-A-read-wrap > div ul.box22 {
  padding: 20px 0;
}
.menu-A-read-wrap > div ul li {
  width: 100%;
  font-size: 14px;
  line-height: 1.7em;
}

.menu-A-read-wrap > div ul li:nth-child(1) {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}
.menu-A-read-wrap > div ul li dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 22px 0;
  border-bottom: 1px solid #ddd;
}

.menu-A-read-wrap > div ul li dl dt {
  width: 100%;
  margin-bottom: 10px;
}
.menu-A-read-wrap > div ul li dl dd {
  line-height: 1.7em;
  width: 100%;
}

.menu-A-read-wrap div.btn {
  margin-top: 50px;
  text-align: center;
}
.menu-A-read-wrap div.btn a {
  display: inline-block;
  text-align: center;
  font-size: 15px;
  background: #fff;
  color: #004e31;
  padding: 5px 25px;
  transition: all 0.2s;
  border: 1px solid #004e31;
  font-weight: 500;
}

@media (min-width: 768px) {
  .menu-A-read-wrap > div ul li dl {
    align-items: center;
  }
  .menu-A-read-wrap > div ul li dl.line3 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul.line {
    border-bottom: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li dl.line2 {
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul.line4 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 180px;
    padding: 0;
    text-align: center;
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 200px);
  }
  .menu-A-read-wrap > div ul li {
    font-size: 15px;
  }
  .menu-A-read-wrap > div ul li dl dt {
    width: 80px;
    margin-bottom: 0;
  }
  .menu-A-read-wrap > div ul li dl dd {
    line-height: 1.7em;
    width: calc(100% - 90px);
  }
}

@media screen and (min-width: 1100px) {
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 270px;
    padding: 0;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 320px);
  }
}
</style>
